import React from "react";
import whatsappIcon from "../../../../assets/images/whatsapp-icon.svg";
import callIcon from "../../../../assets/images/call-icon.svg";

function OTPPopup({
  visible,
  onClose,
  handleOtpWhatsapp,
  handleOtpCall,
  getTranslateText,
}) {
  if (!visible) return null;
  const getTextByKey = (key, fallback) => {
    const item = getTranslateText?.data?.find((item) => item.pageKey === key);
    return item?.keyValue || fallback;
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-2xl w-[75%] md:w-[35%] p-12 relative shadow-lg">
          {/* Close Icon */}
          <button
            className="absolute top-4 right-4 text-gray-600 hover:text-black text-3xl"
            onClick={onClose}
          >
            &times;
          </button>

          {/* Title */}
          <h2 className="text-center text-[#7A80A0] mb-6 text-grey">
            {getTextByKey("key_choose_option", "Choose Option")}
          </h2>
          {/* Buttons */}
          <div className="flex flex-col gap-4">
            {/* Call Button */}
            <button
              className="bg-white border border-gray-300 text-black rounded-[10px] text-[14px] text-[#1B244D] py-3 flex items-center justify-center gap-2 hover:bg-gray-100"
              onClick={handleOtpCall}
            >
              <img src={callIcon} className="w-[25px]" />{" "}
              {getTextByKey("otp_on_call", "OTP on Call")}
            </button>

            {/* WhatsApp Button */}
            <button
              className="bg-white border border-gray-300 text-black rounded-[10px] text-[14px] text-[#1B244D] py-3 flex items-center justify-center gap-2 hover:bg-gray-100"
              onClick={handleOtpWhatsapp}
            >
              <img src={whatsappIcon} className="w-[25px]" />{" "}
              {getTextByKey("otp_on_whatsapp", "OTP on WhatsApp")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default OTPPopup;
